import { Button, Card, Heading, Inline, Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { useToggle } from '../../../../../common/custom-hooks/toggle';
import CancellationCertificateDialog from './CancellationCertificateDialog';

const inlineStyles = css`
  justify-content: space-between;
`;

const CancellationCertificate = () => {
  const { t } = useTranslation();
  const {
    isOpen: isCancellationCertificateDialogOpen,
    handleClose: handleCloseCancellationCertificateDialog,
    handleOpen: handleOpenCancellationCertificateDialog,
  } = useToggle(false);

  return (
    <>
      <Card>
        <Inline className={inlineStyles}>
          <Stack spacing={8}>
            <Heading level={2}>{t('OrderDetails.CancellationCertificate.Title')}</Heading>
            <Text>{t('OrderDetails.CancellationCertificate.Description')}</Text>
          </Stack>
          <Button
            data-testid="download-cancellation-certificate-button"
            onClick={handleOpenCancellationCertificateDialog}
            variant="primary"
          >
            {t('OrderDetails.CancellationCertificate.Button.Text')}
          </Button>
        </Inline>
      </Card>
      <CancellationCertificateDialog
        isOpen={isCancellationCertificateDialogOpen}
        onClose={handleCloseCancellationCertificateDialog}
      />
    </>
  );
};

export default CancellationCertificate;
